<section>
  <div class="container py-2">
    <div class="card p-3">
      <form [formGroup]="addWorksheetEntryForm" (ngSubmit)="onSubmit()">
        <!-- Date input aligned right -->
        <!-- <div class="row mb-3 justify-content-end">
          <div class="col-12 col-md-4 col-lg-3">
            <div class="form-floating">
              <input type="date" class="form-control" formControlName="entryDate" placeholder="Select a date"
                [max]="today"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('entryDate')?.invalid && addWorksheetEntryForm.get('entryDate')?.touched,
              'is-valid': addWorksheetEntryForm.get('entryDate')?.valid && addWorksheetEntryForm.get('entryDate')?.touched}" />
              <label for="dateInput">Date <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.entryDate">{{worksheetEntryFormErrors.entryDate}}</span>
          </div>
        </div> -->

        <!-- Three inputs row with small space, aligned start, and some padding -->
        <div class="row mb-3 gx-2 px-2">
          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="projectName" placeholder="Enter project name"
                [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('projectName')?.invalid && addWorksheetEntryForm.get('projectName')?.touched,
              'is-valid': addWorksheetEntryForm.get('projectName')?.valid && addWorksheetEntryForm.get('projectName')?.touched}" />
              <label for="totalTickets">Project Name <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.projectName">{{worksheetEntryFormErrors.projectName}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <select class="form-select" formControlName="taskType"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('description')?.invalid && addWorksheetEntryForm.get('description')?.touched,
              'is-valid': addWorksheetEntryForm.get('description')?.valid && addWorksheetEntryForm.get('description')?.touched}">
                <option value="" selected disabled>Select a Task Type</option>
                <option *ngFor="let task of this.getAllWorkingTypeDetails" [value]="task.workingType">
                  {{task?.workingType}}</option>
              </select>
              <label for="totalTickets">Task Type <span class="text-danger">*</span></label>
              <span class="text-danger"
                *ngIf="this.worksheetEntryFormErrors.taskType">{{worksheetEntryFormErrors.taskType}}</span>
            </div>
          </div>


          <div class="col-12 col-md-6 col-lg-4 mb-2 mb-2">
            <div class="form-floating">
              <input type="text" class="form-control" formControlName="description" placeholder="Enter description"
                [readOnly]="this.isReadOnly"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('description')?.invalid && addWorksheetEntryForm.get('description')?.touched,
              'is-valid': addWorksheetEntryForm.get('description')?.valid && addWorksheetEntryForm.get('description')?.touched}" />
              <label for="totalTickets">Description <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.description">{{worksheetEntryFormErrors.description}}</span>
          </div>
        </div>

        <div class="row mb-3 gx-2 px-2">
          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="date" class="form-control" formControlName="entryDate" placeholder="Select a date"
                [max]="today"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('entryDate')?.invalid && addWorksheetEntryForm.get('entryDate')?.touched,
              'is-valid': addWorksheetEntryForm.get('entryDate')?.valid && addWorksheetEntryForm.get('entryDate')?.touched}" />
              <label for="dateInput">Date <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.entryDate">{{worksheetEntryFormErrors.entryDate}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="time" class="form-control" formControlName="startTime" placeholder="Enter Start Time"
                [readOnly]="this.isReadOnly" (change)="onStartTimeChange()"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('startTime')?.invalid && addWorksheetEntryForm.get('startTime')?.touched,
              'is-valid': addWorksheetEntryForm.get('startTime')?.valid && addWorksheetEntryForm.get('startTime')?.touched}" />
              <label for="totalTickets">Start Time <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.startTime">{{worksheetEntryFormErrors.startTime}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="time" class="form-control" formControlName="endTime" placeholder="Enter End Time"
                (change)="onEndTimeChange()" [readOnly]="this.isReadOnly"
                [attr.min]="addWorksheetEntryForm.get('startTime')?.value"
                [ngClass]="{'is-invalid': addWorksheetEntryForm.get('endTime')?.invalid && addWorksheetEntryForm.get('endTime')?.touched,
              'is-valid': addWorksheetEntryForm.get('endTime')?.valid && addWorksheetEntryForm.get('endTime')?.touched}" />
              <label for="totalTickets">End Time <span class="text-danger">*</span></label>
            </div>
            <span class="text-danger"
              *ngIf="this.worksheetEntryFormErrors.endTime">{{worksheetEntryFormErrors.endTime}}</span>
          </div>

          <div class="col-12 col-md-4 col-lg-3 mb-2 mb-2">
            <div class="form-floating">
              <input type="tel" class="form-control" formControlName="totalHours" placeholder="Enter Total Hours"
                readonly />
              <label for="totalTickets">Total Hours </label>
            </div>
          </div>
        </div>


        <!-- Save button centered -->
        <div class="row">
          <div class="col text-center">
            <button type="submit" class="btn btn-success px-4">{{this.isUpdate ? "Update" : "Save" }}</button>
          </div>
        </div>
      </form>
    </div>



    <!-- Table Card -->

    <div class="card p-3">
      <div class="row mb-3">
        <div class="col-12 d-flex flex-column flex-md-row justify-content-between align-items-center">
          <h5 class="text-center text-md-start mb-2 mb-md-0 fw-bold">
            Worksheet Entry Details
          </h5>
          <div class="col-12 col-md-4 col-lg-3">
            <div class="form-floating">
              <select class="form-select" [(ngModel)]="wagsMonth" (change)="wagsMonthBasedDetailsGet(wagsMonth)">
                <option selected disabled value="">Select a Wags Month</option>
                <option *ngFor="let month of getAllWagsMonth">{{month}}</option>
              </select>
              <label for="dateInput">List Of Wags Month</label>
            </div>
          </div>
        </div>
      </div>

      <div class="table-responsive rounded border" style="max-height: 235px; overflow-y: auto; overflow-x: auto;">
        <table class="table table-bordered table-striped mb-0 text-center mb-0 rounded overflow-hidden">
          <thead class="table-light position-sticky top-0" style="z-index: 10;">
            <tr>
              <!-- Rounded corners on top left and right headers -->
              <th class="rounded-start">S.No</th>
              <th>Date</th>
              <th>project Name</th>
              <th>Task type</th>
              <th>Description</th>
              <th>Start Time</th>
              <th>End Time</th>
              <th>Total Hours</th>
              <th>Payment Status</th>
              <th>Edit</th>
              <th class="rounded-end">Remove</th>
            </tr>
          </thead>
          <tbody *ngIf="worksheetEntryDetails.length > 0; else noDataFound">
            <tr *ngFor="let entry of worksheetEntryDetails; let i = index"
              [class.last-row]="i === worksheetEntryDetails.length - 1">
              <td>{{ i + 1 }}</td>
              <td>{{ (entry?.entryDate | date : 'dd-MM-yyyy') || '-' }}</td>
              <td>{{ entry?.projectName || '-' }}</td>
              <td>{{ entry?.taskType || '-' }}</td>
              <td>{{ entry?.description || '-' }}</td>
              <td>{{ (entry?.startTime | date : 'hh:mm aa') || '-' }}</td>
              <td>{{ (entry?.endTime | date : 'hh:mm aa') || '-' }}</td>
              <td>{{ entry?.totalHours || '-' }}</td>
              <td>
                <span class="badge px-3 py-2" [ngClass]="{
            'bg-success': entry?.paymentStatus?.toUpperCase() === 'PAID',
            'bg-danger': entry?.paymentStatus?.toUpperCase() !== 'PAID'
        }">

                  {{
                  entry?.paymentStatus?.toUpperCase() === 'PAID'
                  ? 'Paid'
                  : 'Unpaid'
                  }}

                </span>
              </td>
              <td><i class="fa fa-edit text-primary" (click)="editEntryDetails(entry)"></i></td>
              <td><i class="fa fa-trash text-danger"
                  (click)="removeEntryDetails(entry?.devEmployeeTrackId,entry?.projectName)"></i></td>
            </tr>
          </tbody>
          <ng-template #noDataFound>
            <tr>
              <td colspan="10" class="text-center text-danger fw-bolder">Data Not Found</td>
            </tr>
          </ng-template>
        </table>
      </div>

    </div>

    <div class="py-5"></div>
  </div>
</section>